import ListFilters from "@/common/components/ListFilters";
import { useCities } from "@/common/hooks/queries/useCities";
import useDebounce from "@/common/hooks/useDebounce";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterCityBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: cityOptions,
  } = useCities({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GeoTransformers.optionsTransformer()
    }),
  });

  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[DashboardFilters.City],
          options: [{ label: 'Todas', value: '' }, ...cityOptions],
          value: filters[DashboardFilters.City],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [DashboardFilters.City]: e?.value ? e : null })),
          onInputChange: setSearch,
        }
      ]}
    />
  );
}

export default DashboardFilterCityBadge;
